(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcolecciones"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-circles-slider')) {
    customElements.define(
      'collection-circles-slider',
      class CollectionCirclesSlider extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('[data-scroller]');
          this.previousButton = this.querySelector('[data-previous]');
          this.nextButton = this.querySelector('[data-next]');

          if (!this.scroller || !this.previousButton || !this.nextButton) return;

          this.onScroll = this.updateControls.bind(this);
          this.onPrevious = () => this.move(-1);
          this.onNext = () => this.move(1);

          this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
          this.previousButton.addEventListener('click', this.onPrevious);
          this.nextButton.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.scroller);
          this.querySelectorAll('.collection-circles__item').forEach((item) => this.resizeObserver.observe(item));

          requestAnimationFrame(this.onScroll);
        }

        disconnectedCallback() {
          if (!this.scroller) return;
          this.scroller.removeEventListener('scroll', this.onScroll);
          this.previousButton.removeEventListener('click', this.onPrevious);
          this.nextButton.removeEventListener('click', this.onNext);
          this.resizeObserver?.disconnect();
        }

        move(direction) {
          const firstItem = this.scroller.querySelector('.collection-circles__item');
          if (!firstItem) return;

          const styles = getComputedStyle(this.scroller);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = firstItem.getBoundingClientRect().width + gap;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.scroller.scrollBy({
            left: direction * distance,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }

        updateControls() {
          const maximumScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
          const tolerance = 2;

          this.dataset.overflow = maximumScroll > tolerance ? 'true' : 'false';
          this.previousButton.disabled = this.scroller.scrollLeft <= tolerance;
          this.nextButton.disabled = this.scroller.scrollLeft >= maximumScroll - tolerance;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
